/* eslint-disable default-case */
/* eslint-disable no-underscore-dangle */

import 'core-js';
import 'regenerator-runtime';
import 'intersection-observer';

import themeLogger from './utils/ThemeLogger';
import reactInjector from './utils/ReactInjector';
import 'bootstrap';
import { setupTestimonialsPage } from './pages/testimonials';

import setupMorePosts from './utils/MorePosts';
import '../style/style.scss';
import { setupTheDaily } from './pages/thedaily';
import { setupFilterEvents } from './search/search';

reactInjector(window.reactInjections);
themeLogger(window.logObjs);


// route
const pageType = window._theme.template || window._theme.postType;

switch (pageType) {
// templates that use testimonials
case 'page-testimonials.php':
   setupTestimonialsPage();
   break;
case 'thedaily':
case 'page-thedaily.php':
   setupTheDaily();
   break;
}

if (window.moreButton) {
   setupMorePosts();
}

// initialize tooltips
jQuery(document).ready(() => {
   jQuery('[data-toggle="tooltip"]').tooltip();
});

setupFilterEvents();
